<template>
<div class="col p-0">
    <div class="row">
        <header class="viskase-card-header">
            <div class="header-wrapper">
                <slot name="header"></slot>
                <div class="h3">
                    <slot name="title"></slot>
                </div>
            </div>
        </header>
    </div>
    <div class="row">
        <main class="viskase-card-main">
            <slot></slot>
        </main>
    </div>
    <div class="row">
        <footer class="viskase-card-footer">
            <slot name="footer"></slot>
        </footer>
    </div>
</div>
</template>

<script>
export default {
  name: "ViskaseCard",
  props: {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.footer-wrapper {
  display: flex;
  justify-content: flex-end;
}

.header-wrapper {
  display: block;
}

.header-toolbar {
  display: flex;
  justify-content: space-between;
}

.card-body {
  font-size: 0.9em;
}

.viskase-card-header {
  // color: #a0273b;
  min-height: 5px;
}

.viskase-card-content {
  background-color: rgb(248, 240, 240);
  color: #a0273b;
}

.viskase-card-title {
  font-size: 1.6em;
  font-weight: 900;
}

.viskase-card {
  border-radius: 5px;
  border: 1px solid #a0273b;
}
</style>
